import { render, staticRenderFns } from "./DataCellCommon.vue?vue&type=template&id=61012442&"
import script from "./DataCellCommon.vue?vue&type=script&lang=js&"
export * from "./DataCellCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports